export function removeSpacesAndReplaceComma(value: string): string {
  return value.replaceAll(/\s/g, '').replace(',', '.');
}

/**
 * Utility function to format a number for display in an input element.
 * @param unformattedNumber - The unformatted value, including leading 0:s and trailing commas and 0:s. The value should be a correct number without spaces and with a '.' for decimal separator.
 * @param maxDecimals - The maximum number of decimal places to display.
 * @param decimalSeparator - The decimal separator to use (',' for Swedish, '.' for English). Defaults to ','.
 * @returns The value for the input element formated for easy editing. With leading 0:s and trailing commas.
 */
export function getNumberFormattedForElement(
  unformattedNumber: string,
  maxDecimals: number,
  decimalSeparator: ',' | '.' = ',',
): string {
  if (!unformattedNumber) {
    return '';
  }

  const decimalSplit = unformattedNumber.split('.');
  let decimals = '';
  if (decimalSplit[1]) {
    decimals =
      decimalSplit[1].length > maxDecimals
        ? decimalSplit[1].slice(0, maxDecimals)
        : decimalSplit[1];
  }
  const formattedIntegerPart = decimalSplit[0].replaceAll(
    // bounded by input length of a user-typed numeric string, not attacker-controlled
    // eslint-disable-next-line sonarjs/super-linear-regex
    /\B(?=(\d{3})+(?!\d))/g,
    ' ', // Use non breaking space to avoid breaking the number
  );

  let elementValue =
    formattedIntegerPart + (decimals ? decimalSeparator + decimals : '');

  elementValue = unformattedNumber.endsWith('.')
    ? elementValue + decimalSeparator
    : elementValue;

  return elementValue;
}
